import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';
import updateTagsActions, {
  IUpdateTagsMeta,
} from 'store/actions/library/updateTags';

export default createAsyncReducer<IUpdateTagsMeta, GenericResponse>(
  updateTagsActions,
);
